angular.module('pe4h').controller('RootController', function ($scope, $q, $state, $rootScope, configuration, $http, AuthService, $uibModal, $timeout, $injector, $window, $location, $templateCache, $uibModalStack) {

  $scope.mainLoaded = false;

  $scope.noTravelLimits = "No travel limits";

  //white background on hamburguer press
  $scope.setHamburger = function () {
    $scope.white = false;
    $scope.white2 = false;
  }
  $scope.setHamburger();

  $scope.hamburger = function () {
    $scope.white = !$scope.white;
  }
  //white background on icon press

  $scope.imagePressWhite = function () {
    $scope.white2 = !$scope.white2;
  }

  $scope.maxProposals = 5;

  $scope.travelOptions = [{
    label: "Cannot travel",
    value: 0
  }, {
    label: "Up to 25 miles",
    value: 25
  }, {
    label: "Up to 50 miles",
    value: 50
  }, {
    label: "Up to 100 miles",
    value: 100
  }, {
    label: "Up to 200 miles",
    value: 200
  }, {
    label: "Up to 300 miles",
    value: 300
  }, {
    label: "No travel limits",
    value: null
  },];


  $scope.projectStatesDict = {
    'pendingReview': {
      label: "Pending Review",
      color: '#fdbe41'
    },
    'declined': {
      label: "Declined",
      color: '#fc615d'
    },
    'open': {
      label: "Open",
      color: '#34c84a'
    },
    'hired': {
      label: "Hired",
      color: '#5097cf'
    },
    'closed': {
      label: "Closed",
      color: '#666666'
    },
    'full': {
      label: "Full",
      color: '#ff0000'
    },
    'expired': {
      label: "Expired",
      color: '#666666'
    },
    'invoiceReceived': {
      label: 'Invoice Received',
      color: '#ECBB43'
    },
    'awaitingFunds': {
      label: 'Awaiting Funds',
      color: '#FF0000'
    },
    'invoiceRejected': {
      label: 'Invoice Rejected',
      color: '#FF0000'
    },
    'paymentSubmitted': {
      label: 'Payment Submitted',
      color: '#FF9900'
    },
    'escrowFunded': {
      label: 'Escrow Funded',
      color: '#34c84a'
    },
    'fundsReleaseRequested': {
      label: 'Funds Release Requested',
      color: '#FF0000'
    },
    'completed': {
      label: "Completed",
      color: '#666666'
    },
    'paid': {
      label: "Paid",
      color: '#666666'
    }
  }

  $scope.proposalStatesDict = {
    'submitted': {
      label: "Submitted",
      color: '#34c84a'
    },
    'hired': {
      label: "Hired",
      color: '#5097cf'
    },
    'closed': {
      label: "Closed",
      color: '#666666'
    },
    'invoiceSent': {
      label: 'Invoice Sent',
      color: '#ECBB43'
    },
    'invoiceApproved': {
      label: 'Invoice Approved',
      color: '#FF9900'
    },
    'invoiceRejected': {
      label: 'Invoice Rejected',
      color: '#FF0000'
    },
    'paymentSubmitted': {
      label: 'Payment Submitted',
      color: '#FF9900'
    },
    'escrowFundedDisReq': {
      label: 'Escrow Funded',
      color: '#34c84a'
    },
    'escrowFunded': {
      label: 'Escrow Funded',
      color: '#34c84a'
    },
    'fundsRequested': {
      label: 'Funds Requested',
      color: '#34c84a'
    },
    'completedDisReq': {
      label: "Completed",
      color: '#666666'
    },
    'completed': {
      label: "Completed",
      color: '#666666'
    },
    'paid': {
      label: "Paid",
      color: '#666666'
    }
  }

  $scope.licensesDict = {};
  $scope.statesDict = {};

  $scope.loadUser = function (data) {
    $scope.user = data;
  }

  $scope.deleteUser = function () {
    $scope.user = undefined;
    AuthService.delete();
  }

  $scope.getLicenseInformation = function () {
    var df = $q.defer();
    $http({
      url: configuration.webApi.licenses.information,
      method: "GET"
    }).success(function (res, status, headers, config) {
      $scope.licensesInformation = res;
      df.resolve();
    }).error(function (error, status, headers, config) {
      $scope.alertErrorFromServer(error);
      df.reject();
    });

    return df.promise;
  };

  $scope.getLicenses = function () {
    var df = $q.defer();
    $http({
      url: configuration.webApi.licenses.licenses,
      method: "GET"
    }).success(function (res, status, headers, config) {
      $scope.licenses = res;
      for (var i = 0; i < res.length; i++) {
        $scope.licensesDict[res[i].Id] = res[i];
      }
      df.resolve();
    }).error(function (error, status, headers, config) {
      $scope.alertErrorFromServer(error);
      df.reject();
    });

    return df.promise;
  };

  $scope.getStates = function () {
    var df = $q.defer();
    $http({
      url: configuration.webApi.states.states,
      method: "GET"
    }).success(function (res, status, headers, config) {
      $scope.states = res;
      for (var i = 0; i < res.length; i++) {
        $scope.statesDict[res[i].Code] = res[i];
      }
      df.resolve();
    }).error(function (error, status, headers, config) {
      $scope.alertErrorFromServer(error);
      df.reject();
    });

    return df.promise;
  }


  var getUserSession = function () {
    var df = $q.defer();

    var exists = AuthService.get();
    if (exists) {
      $http({
        url: configuration.webApi.auth.token,
        method: "POST",
        data: {
          token: exists
        }

      }).success(function (res, status, headers, config) {
        AuthService.save(res.Token);
        $scope.loadUser(res.User);
        df.resolve();

      }).error(function (error, status, headers, config) {
        // Token expired/invalid
        df.resolve();

      });
    } else {
      df.resolve();
    }

    return df.promise;
  }

  var logoutExpiredTimeout = null;
  $scope.$on('logoutExpired', function (evt, data) {
    // Kill any previous modal and timeout
    // timeout used to prevent modal flood

    if (logoutExpiredTimeout) {
      $timeout.cancel(logoutExpiredTimeout);
    }

    logoutExpiredTimeout = $timeout(function () {
      $injector.get('$uibModalStack').dismissAll();
      if ($scope.user)
        $scope.alertError('Info', "Session expired.");
      $scope.deleteUser();
      $state.go('login', {});
      logoutExpiredTimeout = null;
    }, 100)
  });

  $scope.$on('forbidden', function (evt, data) {
    //TODO change this for something pretier
    if (!data || !data.Detail) {
      $scope.alertError('Info', "You can't see this.");
    }
    else {
      $scope.alertErrorFromServer(data, null, 'Sorry');
    }
    $scope.redirectHome();
  });

  $scope.getLicenseFromId = function (id) {
    return $scope.licensesDict[id];
  }

  $scope.getStateFromCode = function (id) {
    return $scope.statesDict[id];
  }

  $scope.getTravelDistanceMiles = function (d) {
    if (d == null)
      return $scope.travelOptions[$scope.travelOptions.length - 1];
    var v = parseInt(d / 1609.34);
    for (i in $scope.travelOptions)
      if (($scope.travelOptions[i].value <= (v + 1)) && ($scope.travelOptions[i].value >= (v - 1)))
        return $scope.travelOptions[i];
  }

  $scope.toBoolean = function (b) {
    if (b == "yes")
      return true;
    else if (b == "no")
      return false;
  }

  $scope.toYesOrNo = function (b) {
    if (b)
      return "Yes";
    else
      return "No";
  }

  $scope.getMessages = function () {
    var df = $q.defer();
    $http({
      url: configuration.webApi.popUpMessages.messages,
      method: "GET"
    }).success(function (res, status, headers, config) {
      $scope.messages = res;
      
      var criticalMessagesName = [
        "pe4hFeePercentage",
        "escrowFeePercentage",
        "creditCardFeePercentage",
        "wireTransferFeePercentage",
        "wireTransferFlatFee",
        "creditCardLimit", 
        "creditCardLimitExceedFeePercentage"
      ];

      $scope.criticalMessageNotFound = false;

      for(var i=0; i<criticalMessagesName.length && !$scope.criticalMessageNotFound; i++){
        var currentMessageName = criticalMessagesName[i];
        var message = $scope.messages.find(function(m){ return m.MessageName === currentMessageName; });
        if(!message)
        $scope.criticalMessageNotFound = true;
        else
          $scope[currentMessageName] = message.MessageText;
      }

      if($scope.criticalMessageNotFound) {
        $scope.alertError('Error', "Could not retrieve information from server.");
        $scope.deleteUser();
        $state.go('index', {});
        df.resolve();
      }

      df.resolve();
    }).error(function (error, status, headers, config) {
      $scope.alertErrorFromServer(error);
      df.reject();
    });

    return df.promise;
  };

  function replaceMessageText(textToBeReplaced, variableNameToBeReplaced) {

    // First look for the variable in the scope (fee percentages should be here, for instance)
    var messageText = $scope[variableNameToBeReplaced];

    // Then, look for in messagesFrom DB
    if (!messageText) {
      var messageFromDB = $scope.messages && $scope.messages.find(m => m.MessageName === variableNameToBeReplaced);
      messageText = messageFromDB && messageFromDB.MessageText;
    }

    // Then, look for in default messages
    if (!messageText)
      messageText = configuration.default_messages[variableNameToBeReplaced];

    var updatedText;
    var regExp = new RegExp("{{" + variableNameToBeReplaced + "}}", 'g');
    if (messageText) {
      updatedText = textToBeReplaced.replace(regExp, messageText);
    } else {
      updatedText = textToBeReplaced.replace(regExp, "");
    }

    return updatedText;
  }

  $scope.getMessagesParagraphs = function (messageName, messageNameToBeReplaced) {
    var messageFromDB = $scope.messages && $scope.messages.find(m => m.MessageName === messageName);
    var messageText = messageFromDB && messageFromDB.MessageText;

    if (!messageText) {
      messageText = configuration.default_messages[messageName];
    }

    if (messageText && messageNameToBeReplaced) {
      messageText = replaceMessageText(messageText, messageNameToBeReplaced);
    }

    if (messageText) {
      messageText = messageText.split('\n');
    }

    if (!messageText)
      return []

    return messageText;
  }

  $scope.getMessageWithoutParagraphs = function (messageName, messageNameToBeReplaced) {
    var messageFromDB = $scope.messages && $scope.messages.find(m => m.MessageName === messageName);
    var messageText = messageFromDB && messageFromDB.MessageText;

    if (!messageText) {
      messageText = configuration.default_messages[messageName];
    }

    if (messageText && messageNameToBeReplaced) {
      messageText = replaceMessageText(messageText, messageNameToBeReplaced);
    }

    if (!messageText)
      return []

    return messageText;
  }

  $scope.init = function () {
    $q.all([$scope.getLicenses(), $scope.getLicenseInformation(), $scope.getStates(), getUserSession(), $scope.getMessages()]).then(function (data) {
      $scope.mainLoaded = true;
      $scope.year = new Date().getFullYear();

      // This is needed so route is loaded once main init.
      $state.reload();
    }, function (err) {
      alert("Failed to load page.");
    });
  }

  function createNextUrl(url, params) {

  }

  // Keep reference to previous state
  // and also validate urls that can only be used with login to redirect away from it.
  $rootScope.$on('$stateChangeStart', function (event, to, toParams, from, fromParams) {
    $rootScope.hideNavBar();
    if (to && to.params && to.params.requiresLogin && $scope.mainLoaded && !$scope.user) {
      event.preventDefault();
      if (from.name !== "index" && from.name !== "login") {
        $rootScope.previousState = from;
        $rootScope.previousParams = fromParams;
        var nextUrl = $state.href(to.name, toParams);
        $state.go('login', { "next": from.name, "params": JSON.stringify(fromParams) });
      } else {
        $state.go('login', {});
      }

    }
    //prevent professional from seeing post-project and projects
    if (to && $scope.mainLoaded && $scope.user && $scope.user.IsProfessional && (to.name == 'post-project' || to.name == 'projects')) {
      event.preventDefault();
      $scope.redirectHome();
    }
    //prevent client from seeing requests and proposals
    if (to && $scope.mainLoaded && $scope.user && $scope.user.IsClient && (to.name == 'requests' || to.name == 'proposals')) {
      event.preventDefault();
      $scope.redirectHome();
    }
  });

  // $rootScope.$on('$stateChangeError', function(event, toState, toParams, fromState, fromParams, error){
  //   debugger;
  //   console.log(event)
  // });

  $rootScope.$on('$stateChangeSuccess', function (event) {
    gtag('event', 'page_view', {'page_path': $location.path()});
  });

  // Simple alert error.
  // msg can be string or list of strings
  $scope.alertError = function (header, msg, closeCallback, recoverPassword) {
    // Error alert modal
    if (!window.prerenderCloudIsServerSideRendering) {
      var modalResult = $uibModal.open({
        templateUrl: 'components/root/alert-error.html',
        size: 'md',
        scope: $scope,
        controller: ["$scope", "$uibModalInstance", "$q", function ($scope, $uibModalInstance, $q) {
          $scope.header = header;
          $scope.msg = msg;
          $scope.recoverPassword = recoverPassword || false;
          $scope.isList = typeof msg != 'string';
        }]
      });

      modalResult.closed.then(function () {
        if (closeCallback) {
          closeCallback();
        } else {
          $uibModalStack.dismissAll();
        }
      });
    }
  }

  // Alert error from server response for the lazy. Works with both styles of promise result (data.data and only data)
  // Should not be abused.
  $scope.alertErrorFromServer = function (serverData, closeCallback, header, recoverPassword) {
    // only alert if we have data, otherwise ignore since connection and session expired
    // errors are already handled
    if (serverData && (serverData.data || serverData.Code)) {
      var err = configuration.processError(serverData.data ? serverData.data : serverData);
      if(err.message == "Payment method already set"){
        err.message = $scope.getMessagesParagraphs("paymentMethodAlreadySet");
        if(err.message.length == 1){
          err.message = $scope.getMessagesParagraphs("paymentMethodAlreadySet")[0];
        }
        header = "Thank You!";
        $scope.alertError(header, err.message || err.messageList, closeCallback, recoverPassword);
      }
      $scope.alertError(header || "Error", err.message || err.messageList, closeCallback, recoverPassword);
    }

  };
  $scope.visibleHeaderFooter = function () {
    if ($state.current.name == 'forgotPassword' || $state.current.name == 'login' || $state.current.name == 'first-step' || $state.current.name == 'signup' || $state.current.name == 'recoverPassword' || ($state.current.name == 'legal' && $state.params.standAlone) || ($state.current.name == 'terms' && $state.params.standAlone))
      return false;
    else
      return true;
  }

  $scope.animateHeader = true;

  var windowEl = angular.element($window);

  $scope.showBackToTop = function () {
    if (windowEl.scrollTop() < 100) {
      return true;
    } else {
      return false;
    }
  }

  $scope.animateHeader2 = function () {
    if ($state.current.name == 'index' && windowEl.scrollTop() < 100) {
      return true;
    } else {
      return false;
    }
  }
  var handler = function () {
    if ($state.current.name == 'index' && windowEl.scrollTop() < 100) {
      $scope.animateHeader = true;
    } else {
      $scope.animateHeader = false;
    }
    $scope.$apply();
  }
  windowEl.on('scroll', handler);


  $scope.redirectHome = function () {
    if ($scope.user.IsProfessional) {
      $state.go("proposals");
    } else {
      $state.go("projects");
    }
  };

  $scope.goToTop = function () {
    $("html, body").animate({
      scrollTop: 0
    }, 500);
  };

  $scope.openCopyProjectUrl = function (stateName, params) {
    var url = $state.href(stateName, params);
    if (!configuration.debug.isDevEnvironment) {
      url = url.substring(1, url.length);
    }
    var full_url = configuration.pe4hUrl + url;

    var clipboard = new Clipboard('#btnClipboard');

    var copyProjectUrlModalResult = $uibModal.open({
      template: $templateCache.get('components/root/copy-project-url.html'),
      size: 'md',
      scope: $scope,
      controller: ["$scope", "$uibModalInstance", function ($scope, $uibModalInstance) {
        $scope.project = {};
        $scope.project.url = full_url;
        $scope.goToUrl = function () {
          $uibModalInstance.close(copyProjectUrlModalResult);
          $state.go(stateName, params);
        };
        $scope.popUp = false;
        $scope.open = function () {
          $scope.popUp = true;
          $timeout(function () {
            $scope.popUp = false;
          }, 1000);

        }

      }]
    });

    copyProjectUrlModalResult.closed.then(function () {
      clipboard.destroy();
    });
  };
});
